import React from 'react';
import PropTypes from 'prop-types';
import Layout from '../layouts/Layout';
import Header from '../modules/Header';
import Footer from '../modules/Footer';
import EmptySpace from '../modules/EmptySpace';
import EmailSignature from './EmailSignature';
import { url } from '../../../config';
import { PRIMARY_COLOR, GRAY_BG_COLOR } from '../../../constants';

//Style
import { body, buttonStyle, fontWeightBold, marginBottom } from '../../../helpers/getEmailStyles';

class ConfirmDocumentVerification extends React.Component {

  static propTypes = {
    content: PropTypes.shape({
      verificationStatus: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired
    })
  };

  render() {
    const { content: { verificationStatus, name, logo, siteName } } = this.props;
    let verificationURL = url + `/user/verification`;

    return (
      <Layout>
        <Header color={PRIMARY_COLOR} backgroundColor={GRAY_BG_COLOR} logo={logo} siteName={siteName} />
        <div style={body}>
          <div style={fontWeightBold}>
            Bonjour {name},
          </div>
          <EmptySpace height={20} />
          <div>
            {
              verificationStatus == 'approved' ?
                <div style={marginBottom}>Bonne nouvelle ! La vérification de vos documents est terminée et l'administrateur a validé vos documents avec succès.</div>
                : <div>
                  Malheureusement, vos documents soumis ont été refusés par l'administrateur.
                </div>
            }
          </div>
          <EmptySpace height={10} />
          {verificationStatus == 'approved' ? <div>
            <div>
              Cliquez sur le bouton ci-dessous pour voir votre profil :
            </div>
            <EmptySpace height={20} />
            <div>
              <a style={buttonStyle} href={verificationURL}>Cliquez ici</a>
            </div>
            <EmptySpace height={20} />
          </div> : <div>
            Si vous avez besoin d'aide, n'hésitez pas à nous contacter.
          </div>
          }
          <EmptySpace height={40} />
          <EmailSignature siteName={siteName} />
        </div>
        <Footer siteName={siteName} />
        <EmptySpace height={20} />
      </Layout>
    );
  }

}

export default ConfirmDocumentVerification;